<template>
  <div class="device-monitor-header" @mouseenter="handleMouseenter" @mouseleave="handleMouseleave">
    <div class="header-content" :class="{ hide: !headerVisible }">
      <div class="left">
        <div class="title">{{ $t('设备监控') }}</div>
      </div>
      <div class="right">
        <el-dropdown v-if="hasSetLines" style="margin-right: 5px">
          <div class="dropdown-btn">
            <i class="iconfont el-icon-s-tools" style="font-size: 16px; cursor: pointer"></i>
          </div>

          <el-dropdown-menu slot="dropdown">
            <template v-for="item in linsNumOptions">
              <el-dropdown-item :key="item.key" @click.native="lineNumsSetHandle(item)">
                {{ $t(item.title) }}
                <i v-if="complinesNum == item.key" class="el-icon-check"></i>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>

        <el-tooltip v-if="hasFixed" effect="dark" :content="$t('固定导航栏')">
          <em
            class="icon iconfont"
            :class="monitorConfig.fixedHeader ? 'icon-thumb-tack' : 'icon-thumb-tack-slant'"
            @click="handleFixedHeader"
          ></em>
        </el-tooltip>

        <el-popover
          v-if="hasResize"
          v-model="popoverVisible"
          placement="bottom"
          width="400"
          trigger="hover"
        >
          <el-slider
            v-model="monitorConfig.fontSize"
            :step="1"
            :min="14"
            :max="60"
            :format-tooltip="formatTooltip"
          />
          <em slot="reference" class="icon iconfont icon-font-size"></em>
        </el-popover>

        <el-tooltip effect="dark" :content="$t(fullScreen ? '退出全屏' : '进入全屏')">
          <em
            class="icon iconfont"
            :class="fullScreen ? 'icon-quitquanping' : 'icon-quanping'"
            @click="screenToggle"
          ></em>
        </el-tooltip>

        <el-tooltip v-if="hasSettings" effect="dark" :content="$t('设置')">
          <em class="icon el-icon-setting" @click="openSettingsPanel"></em>
        </el-tooltip>

        <el-radio-group v-model="monitorModeRadio" size="mini">
          <el-radio-button v-for="v in modeList" :label="v.key" :key="v.key">
            {{ $t(v.text) }}
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <el-drawer
      :title="$t('settings')"
      :size="inLangs('zh') ? '450px' : '550px'"
      :modal="false"
      :append-to-body="false"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :withHeader="true"
      :visible.sync="drawerVisible"
    >
      <MForm
        :config="formConfig"
        :i18nPath="i18nPath"
        :model="monitorConfig"
        :dataSource="dataSource"
      />
    </el-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Type from '@/store/mutation-type';
import screenfull from 'screenfull';

import MForm from '@/components/form/index.vue';

export default {
  components: { MForm },
  inject: ['getMonitorCtx', 'getMonitorEl'],
  data() {
    return {
      i18nPath: 'part',
      visible: false,
      fullScreen: false,
      popoverVisible: false,
      projectId: '',
      selectParams: {
        clearable: true,
        disabled: false,
        placeholder: '全部项目'
      },
      treeParams: {
        data: [],
        filterable: true,
        checkStrictly: true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        }
      },
      linsNumOptions: [
        {
          title: '每行2个',
          key: 2
        },
        {
          title: '每行4个',
          key: 4
        },
        {
          title: '每行6个',
          key: 6
        }
      ],
      mouseleaveTimer: null,
      drawerVisible: false,
      formConfig: {
        labelWidth: '183px',
        span: 24,
        options: [
          {
            type: 'switch',
            label: '界面排版:',
            prop: 'multiColumn',
            show: () => {
              return ['list'].includes(this.monitorMode);
            },
            attrs: {
              // activeColor: '#13ce66',
              // inactiveColor: '#ff4949',
              activeText: '多列',
              inactiveText: '单列'
            }
          },
          {
            type: 'switch',
            label: '分组方式:',
            prop: 'groupBy',
            show: () => {
              return ['list'].includes(this.monitorMode);
            },
            attrs: {
              // activeColor: '#13ce66',
              // inactiveColor: '#ff4949',
              activeText: '设备类型',
              inactiveText: '设备位置',
              activeValue: 'deviceType',
              inactiveValue: 'place'
            }
          },
          {
            type: 'radioGroup',
            label: '字体大小:',
            prop: 'fontSize',
            dataKey: 'radioOptions',
            show: () => {
              return ['list'].includes(this.monitorMode);
            }
          },
          {
            type: 'switch',
            label: '固定导航栏:',
            prop: 'fixedHeader',
            attrs: {
              // activeColor: '#13ce66',
              // inactiveColor: '#ff4949',
              activeText: '固定',
              inactiveText: '不固定'
            },
            show: () => {
              return ['list', 'alarm'].includes(this.monitorMode);
            }
          },
          {
            type: 'switch',
            label: '报警处置:',
            prop: 'enableAlarmDisposition',
            show: () => {
              return ['list'].includes(this.monitorMode);
            },
            attrs: {
              // activeColor: '#13ce66',
              // inactiveColor: '#ff4949',
              activeValue: true,
              inactiveValue: false,
              activeText: '启用',
              inactiveText: '不启用'
            }
          },
          {
            type: 'radioGroup',
            label: '地图类型:',
            prop: 'mapType',
            dataKey: 'bmapTypeList',
            show: () => {
              return ['map'].includes(this.monitorMode);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState('socket', ['deviceTree']),
    ...mapState('device', ['modeList', 'monitorMode', 'monitorConfig']),
    ...mapState('admin', ['profile']),
    complinesNum() {
      return this.monitorConfig.deviceTreeLineNum;
    },
    dataSource() {
      const bmapTypeList = [
        { label: '标准地图', value: 'B_NORMAL_MAP' },
        { label: '地球模式', value: 'B_EARTH_MAP' },
        { label: '普通卫星地图', value: 'B_SATELLITE_MAP' }
      ];

      // 适配离线地图
      if (this.profile.mapTile) {
        bmapTypeList.splice(1, 1);
      }

      return {
        radioOptions: [
          { label: '特大', value: 60 },
          { label: '大', value: 44 },
          { label: '中', value: 30 },
          { label: '小', value: 18 }
        ],
        bmapTypeList
      };
    },
    monitorModeRadio: {
      get() {
        return this.monitorMode;
      },
      set(v) {
        this.setMonitorMode(v);
      }
    },
    headerVisible() {
      if (!['list', 'alarm'].includes(this.monitorMode)) return true;
      return this.visible || this.popoverVisible || this.monitorConfig.fixedHeader;
    },
    hasSetLines() {
      return ['home'].includes(this.monitorMode);
    },
    hasFixed() {
      return ['list', 'alarm'].includes(this.monitorMode);
    },
    hasResize() {
      return ['list'].includes(this.monitorMode);
    },
    hasSettings() {
      return ['list', 'map'].includes(this.monitorMode);
    }
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    openSettingsPanel() {
      this.drawerVisible = true;
    },
    handleFixedHeader() {
      this.monitorConfig.fixedHeader = !this.monitorConfig.fixedHeader;
    },
    formatTooltip(v) {
      return `${v}px`;
    },
    handleMouseenter() {
      if (this.mouseleaveTimer) clearTimeout(this.mouseleaveTimer);
      this.show();
    },
    handleMouseleave() {
      if (this.mouseleaveTimer) clearTimeout(this.mouseleaveTimer);
      this.mouseleaveTimer = setTimeout(() => {
        this.hide();
      }, 600);
    },
    ...mapMutations('device', {
      setMonitorMode: Type.SET_MONITOR_MODE
    }),
    setTreeData(n) {
      this.treeParams.data = n;
    },
    treeFilter(v) {
      this.$refs.elTreeSelect.filterFun(v);
    },
    screenToggle() {
      if (screenfull.isEnabled) {
        screenfull.toggle(this.getMonitorEl());
      }
    },
    lineNumsSetHandle(val) {
      this.monitorConfig.deviceTreeLineNum = val.key;
    }
  },
  mounted() {
    screenfull.onchange(() => {
      this.fullScreen = !this.fullScreen;
    });
  },
  watch: {
    deviceTree: {
      handler: 'setTreeData',
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss">
.device-monitor-header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;

  width: 100%;
  height: 60px;
  user-select: none;

  .header-content {
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 100%;

    padding: 0 20px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.2);

    transition: top 0.5s;
    &.hide {
      top: -100%;
    }
  }

  .left {
    display: flex;
    align-items: center;

    .title {
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: var(--monitor-header-title-color, #b1fffc);

      line-height: 1;
      border-left: 4px solid var(--monitor-header-border-color, #f1ff52);
      padding-left: 10px;
      margin-right: 15px;
    }
  }

  .right {
    display: flex;
    align-items: center;

    .icon {
      font-size: 16px;
      color: var(--monitor-header-icon-color, #0ef);
      justify-content: space-between;

      margin-right: 10px;
      cursor: pointer;
    }
  }

  .el-drawer__body {
    padding: 0 20px;
  }
}
</style>
